import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  id: any;
  userGroupId: any;
  name: any;
  email: any;
  password: any;
  isActive: any;
  subdomain: any;
  signature: any;
  userPermission: any;
  userPersonalData: any;
  userGroup: any;
  userAdministrationCompanies: any[];
  props: {
    [key: string]: any;
  };
}

const initialState: UserState = {
  id: '',
  userGroupId: '',
  name: '',
  email: '',
  password: '',
  isActive: false,
  subdomain: '',
  signature: '',
  userPermission: {},
  userPersonalData: {},
  userGroup: {},
  userAdministrationCompanies: [],
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Partial<UserState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<UserState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },

    updateField: (state: UserState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    addUserAdministrationCompanies: (state, action: PayloadAction<any>) => {
      state.userAdministrationCompanies.push(action.payload);
    },

    updateUserAdministrationCompanies: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (state.userAdministrationCompanies[index]) {
        state.userAdministrationCompanies[index] = {
          ...state.userAdministrationCompanies[index],
          ...updates,
        };
      }
    },

    removeUserAdministrationCompanies: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (index >= 0 && index < state.userAdministrationCompanies.length) {
        state.userAdministrationCompanies.splice(index, 1);
      }
    },

    updateUserPersonalDataField: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.userPersonalData = {
        ...state.userPersonalData,
        [field]: value,
      };
    },

    updateUserPermissionFields: (state, action: PayloadAction<Record<string, any>>) => {
      state.userPermission = {
        ...state.userPermission,
        ...action.payload,
      };
    },
  },
});

export const {
  setUser,
  resetProps,
  updateProps,
  updateField,
  addUserAdministrationCompanies,
  updateUserAdministrationCompanies,
  removeUserAdministrationCompanies,
  updateUserPersonalDataField,
  updateUserPermissionFields,
} = userSlice.actions;

export default userSlice.reducer;
